module.exports = __webpack_public_path__ + "static/media/1005432.7b393281.jpg";